import axios, { AxiosRequestConfig } from 'axios';

export interface IAxiosResp<T> {
  code: number;
  msg: string; // message
  success: boolean;
  data?: T;
  [key: string]: any;
}

const defaultConfig = {
  baseURL: ``,
};

const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (resp) => {
    return resp;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export const $PUT = async <T>(
  url: string,
  payload: object = {},
  config?: AxiosRequestConfig<any>,
  initData?: T
): Promise<IAxiosResp<any>> => {
  const resp = await instance.put<any>(url, payload, config);
  const etag = resp.headers.etag.replace(/(^"|"$)/g, ''); // 去除两侧的引号

  return {
    code: 0,
    msg: '',
    success: true,
    data: {
      etag,
    },
  };
};

export default instance;
